import * as React from "react";
import { forwardRef } from "react";
const SvgQuestion = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M38.226 3.496c-8.314 2.075-15.68 6.89-19.575 14.66-1.567 3.282-2.923 6.867-3.404 10.514-.584 3.267.214 6.34 3.555 6.944l17.333 1.088c2.311.282 4.049-1.44 4.689-3.265.894-2.616 1.245-5.268 4.413-6.554 4.43-1.799 10.284 2.23 6.258 6.396-4.842 6.114-12.488 9.768-16.127 16.857-2.028 4.441-1.592 9.429-1.494 14.173.557 3.294 4.133 3.394 6.764 3.24l13.223-.02c4.157.393 5.655-3.347 5.472-6.825-.268-4.326 4.511-6.016 7.046-8.653 6.31-5.217 11.802-12.404 11.874-20.95.884-9.696-4.093-19.622-12.623-24.413-9.335-4.484-17.787-5.541-27.404-3.192m11.644 70.54-6.855.034c-4.496.022-8.955 3.095-8.924 7.322l.078 10.59c.032 4.383 4.303 6.932 8.394 6.962l7.8.058c4.25.032 8.88-3.219 8.842-7.314l-.097-10.5c-.04-4.4-5.172-7.173-9.238-7.153" />
  </svg>
);
const ForwardRef = forwardRef(SvgQuestion);
export default ForwardRef;
